module.exports = __webpack_public_path__ + "img/bad_modpas.c6da63ec.jpg";